import logo from './azaro2.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="App-header">
        <img src={logo} className="App-logo" alt="logo"/>
        <div className="App-panel">
          <span>Azaro Labs</span>
        </div>
        <div className={"App-circle-container"}>
          <div className="App-circle"/>
          <div className="App-circle"/>
          <div className="App-circle"/>
        </div>
        <span className="subheading">We design and build apps for humans.</span>
        <span className="copyright">&copy; 2022 - {new Date().getUTCFullYear()} Azaro Labs LLC</span>
      </div>
    </div>
  );
}

export default App;
